import { getKeys } from 'dataLayer/recoil/helpers/objectHelpers';

export const getAllTraits = (object) => {
  const sectionKeys = getKeys(object);
  let allTraits = [];
  sectionKeys.forEach((sectionKey, index) => {
    const sectionTraits = getSectionTraits(sectionKey, object);

    sectionTraits.forEach((trait) => {
      const traitAlreadyExists = allTraits.some(
        (allTraitsItem) => allTraitsItem.trait.code === trait.trait.code
      );
      if (!traitAlreadyExists) {
        allTraits.push(trait);
      }
    });
  });

  return allTraits;
};

/* TODO: remove this after infinite load is implemented */
export const getAllTraitsWithLimit = (object) => {
  let allTraits = getAllTraits(object);
  let traitsWithLimit = allTraits;
  if (allTraits.length > 20) {
    traitsWithLimit = allTraits.slice(0, 20);
  }
  return traitsWithLimit;
};

export const getSectionTraits = (sectionKey, object) => {
  const dnaObject = { ...object[sectionKey].dna };
  const dnaKeys = getKeys(dnaObject);

  let sectionTraits = [];
  dnaKeys.forEach((dnaKey, index) => {
    sectionTraits.push(...dnaObject[dnaKey].traits);
  });

  return sectionTraits;
};

/* Returns filtered traits that are level 1 or 2 traits */
export const getFilteredSectionTraits = (sectionKey, object) => {
  let sectionTraits = getSectionTraits(sectionKey, object);

  let filteredSectionTraits = sectionTraits.filter((item) => {
    return item.level === 1 || item.level === 2;
  });

  return filteredSectionTraits;
};

export const mapTraits = (traits) => {
  let mappedTraits = [];
  traits.map((trait) => {
    return mappedTraits.push({
      title: trait.trait.name.toUpperCase(),
      firstCircle: { label: trait.level_label },
      secondCircle: {
        label: 'GENETIC VARIATIONS',
        value: trait.num_genetic_variations,
      },
      thirdCircle: { label: 'POPULATION PERCENTILE', value: trait.percentile },
      buttonUrl: trait.trait.code,
      paragraph: trait.trait.description,
      geneticVariations: trait.genetic_variations_selection,
      references: trait.references,
    });
  });

  return mappedTraits;
};
